import me from "./me"
import loadFromStorage from "./loadFromStorage"
import registerUser from "./registerUser"
import getTokens from "./getTokens"
import googleLogin from "./googleLogin"
import linkGoogle from "./linkGoogle"
import unlinkGoogle from "./unlinkGoogle"
import changeUsername from "./changeUsername"
import deleteAccount from "./deleteAccount"
import getNewAccessToken from "./getNewAccessToken"
import forgotPassword from "./forgotPassword"
import resetPassword from "./resetPassword"
import markBasicTrainingSeen from "./markBasicTrainingSeen"
import guestLogin from "./guestLogin"
import claimGuest from "./claimGuest"
import claimGuestWithGoogle from "./claimGuestWithGoogle"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = {
  me,
  loadFromStorage,
  registerUser,
  getTokens,
  googleLogin,
  linkGoogle,
  unlinkGoogle,
  changeUsername,
  deleteAccount,
  getNewAccessToken,
  forgotPassword,
  resetPassword,
  markBasicTrainingSeen,
  guestLogin,
  claimGuest,
  claimGuestWithGoogle,
}
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
const meThunk = me.thunk
const loadFromStorageThunk = loadFromStorage.thunk
const registerUserThunk = registerUser.thunk
const getTokensThunk = getTokens.thunk
const googleLoginThunk = googleLogin.thunk
const getNewAccessTokenThunk = getNewAccessToken.thunk
const forgotPasswordThunk = forgotPassword.thunk
const resetPasswordThunk = resetPassword.thunk
const linkGoogleThunk = linkGoogle.thunk
const unlinkGoogleThunk = unlinkGoogle.thunk
const changeUsernameThunk = changeUsername.thunk
const deleteAccountThunk = deleteAccount.thunk
const markBasicTrainingSeenThunk = markBasicTrainingSeen.thunk
const guestLoginThunk = guestLogin.thunk
const claimGuestThunk = claimGuest.thunk
const claimGuestWithGoogleThunk = claimGuestWithGoogle.thunk
export {
  meThunk as me,
  loadFromStorageThunk as loadFromStorage,
  registerUserThunk as registerUser,
  getTokensThunk as getTokens,
  googleLoginThunk as googleLogin,
  getNewAccessTokenThunk as getNewAccessToken,
  forgotPasswordThunk as forgotPassword,
  resetPasswordThunk as resetPassword,
  linkGoogleThunk as linkGoogle,
  unlinkGoogleThunk as unlinkGoogle,
  changeUsernameThunk as changeUsername,
  deleteAccountThunk as deleteAccount,
  markBasicTrainingSeenThunk as markBasicTrainingSeen,
  guestLoginThunk as guestLogin,
  claimGuestThunk as claimGuest,
  claimGuestWithGoogleThunk as claimGuestWithGoogle,
}
